//提前加载图片
const preloadImages = () => {
    if(window.innerWidth>750){
        for(let i=1;i<60;i++){
            const img = new Image();
            img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/${i}.avif`;
        }
    }
    for(let i=1;i<99;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nx_box6_new_${i}.avif`;
    }
};
preloadImages()

if(window.innerWidth>750){
    var Wflag = true,box7V = 3,box11V = 2
    $('.box2_items div').hover(function(){
        $('.box2_items div').removeClass('box2_active')
        $(this).addClass('box2_active')
    })
}else{
    Wflag = false,box7V = 1,box11V = 1
    $('.box2_items div').removeClass('box2_active')
}

new Swiper('.box3Swiper', {
	effect: 'fade',
    pagination: {
        el: '.box3_icon',
        clickable: true,
        renderBullet: function (index, className) {
        switch(index){
            case 0:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Chequered_Pink.svg?v=1760663713') center/contain";break;
            case 1:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Chequered_Gray.svg?v=1760663712') center/contain";break;
            case 2:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Chequered_Green.svg?v=1760663712') center/contain";break;
            case 3:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Terrain_Black.svg?v=1760663712') center/contain";break;
            case 4:color='#1A1A1A';break;
            case 5:color='#D4D4D4';break;
            case 6:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Glory_Red.svg?v=1730951244') center/contain";break;
            case 7:color="url('https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Power_Black.svg?v=1730951244') center/contain";break;
            case 8:color='#ebcae7';break;
            case 9:color='#e4b4b4';break;
            case 10:color='#fb8a24';break;
            case 11:color='#ebc830';break;
            case 12:color='#9c9696';break;
            case 13:color='#7f8498';break;
            case 14:color='#50597a';break;
            case 15:color='#496453';break;
            case 16:color='#9f5d43';break;
            case 17:color='#151515';break;
        }
        return '<span class="' + className + '" style="background:'+color+'"></span>';
        },
    },
})

if(Wflag){
    gsap.to('.box3',{
        scrollTrigger:{
            trigger:'.box3',
            start:'top top+=6%',
            end:'+=50%',
            pin:true,
            // markers:true,
        }
    })
    
    gsap.to('.box3_1',{
        scrollTrigger:{
            trigger:'.box3_1',
            start:'top top+=6%',
            end:'+=50%',
            pin:true,
            // markers:true,
        }
    })

    ScrollTrigger.create({
        trigger:'.box3_1',
        start:'top bottom-=40%',
        end:'+=0',
        // markers:true,
        onEnter: () => {
            $('.box3_1 video')[0].play()
        }
    }) 
}else{
    $('.box3_1 video').attr({autoplay:''})
}

ScrollTrigger.create({
    trigger:'.box3_title',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box3_title').addClass('showup')
    },
    onLeaveBack: () => {
        $('.box3_title').removeClass('showup')
    }
})

if(Wflag){
    var box4 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box4',
            start:'top center',
            end:'+=300%',
            scrub:1,
            // markers:true,
        }
    })
    box4.from('.box4_item img',{scale:4,opacity:0})
        .from('.box4_item span',{y:'2rem',opacity:0})
        .to('.box4_item',{x:'-30rem',y:'-2rem',scale:0.65},'+=30%')
        .from('.box4_text1',{y:'2rem',opacity:0})
        .from('.box4_text2',{y:'2rem',opacity:0},'+=20%')
        .to('.box4_text1',{opacity:0},'<')
    
    gsap.to('.box4',{
        scrollTrigger:{
            trigger:'.box4',
            start:'top top+=6%',
            end:'+=300%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                var index = self.progress.toFixed(3) * 100
            }
        }
    })

    gsap.to('.box5',{
        scrollTrigger:{
            trigger:'.box5',
            start:'top center',
            end:'+=150%',
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 59);
                $('.box5_img1').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/${index}.avif`);
            }
        }
    })
    
    var box5_1 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box5',
            start:'top+=180% center',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
        }
    })
    box5_1.from('.box5_content',{opacity:0,y:'2rem',ease:'none',duration:0.5})
    .from('.box5_info div p',{width:0,ease:'none',duration:0.5})
    
    var box5 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box5',
            start:'top+=280% center',
            end:'+=100%',
            scrub:true,
            // markers:true,
        }
    })
    box5.to('.box5_content',{opacity:0,y:'2rem'},'+=80%')
    .to('.box5_img1',{scale:0.65,x:'6rem',y:'-3rem'},'-=40%')
    .to('.box5_item1',{opacity:0},'-=50%')
    
    var box5_2 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box5',
            start:'top+=450% center',
            end:'+=0',
            toggleActions:'play none none reverse',
            // scrub:1,
            // markers:true,
        }
    })
    box5_2.to('.box5_items',{xPercent:'-50'})
    .to('.box5t_1',{opacity:'0'},'-=20%')
    .from('.box5t_2',{opacity:'0',y:'2rem'},'<')
    
    
    gsap.to('.box5',{
        scrollTrigger:{
            trigger:'.box5',
            start:'top top+=6%',
            end:'+=500%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                var index = self.progress.toFixed(3) * 100
            }
        }
    })

    gsap.to('.box6',{
        scrollTrigger:{
            trigger:'.box6',
            start:'top top+=6%',
            end:'+=50%',
            pin:true,
            // markers:true,
        }
    })
}else{
    ScrollTrigger.create({
        trigger:'.Mbox4',
        start:'top bottom-=20%',
        end:'+=0',
        // markers:true,
        onEnter: () => {
            $('.box4_title').addClass('showup')
        },
        onLeaveBack: () => {
            $('.box4_title').removeClass('showup')
        }
    })
    
    gsap.to('.Mbox4',{
        scrollTrigger:{
            trigger:'.Mbox4',
            start:'top top+=6%',
            end:'+=60%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                var index = self.progress.toFixed(3) * 100
                if(index>30){
                    $('.box4_title div').css({opacity:0})
                    $('.box4_title p').css({transform:'translate(-50%)',opacity:1})
                }else{
                    $('.box4_title div').css({opacity:1})
                    $('.box4_title p').css({transform:'translate(-50%,2rem)',opacity:0})
                }
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box5_content',
        start:'top bottom-=20%',
        end:'+=0',
        // markers:true,
        onEnter: () => {
            $('.box5_content').addClass('showup');
        },
        onLeaveBack: () => {
            $('.box5_content').removeClass('showup');
        }
    })

    var box5 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box5_item2',
            start:'top+=20% top+=6%',
            end:'+=100%',
            scrub:true,
            // markers:true,
        }
    })
    box5.to('.box5_items',{xPercent:'-50'})
    .to('.box5t_1',{opacity:'0'},'-=20%')
    .from('.box5t_2',{opacity:'0',y:'2rem'},'<')

    gsap.to('.box5_item2',{
        scrollTrigger:{
            trigger:'.box5_item2',
            start:'top top+=6%',
            end:'+=150%',
            pin:true,
            // markers:true,
        }
    })

}

ScrollTrigger.create({
    trigger:'.box6_title',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box6_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box6_title').removeClass('showup');
    }
})

$('.box6_items div').click(function(){
    var index = $(this).index()+1
    $('.box6_items div').css({background:'#2d2d2d'})
    if(index==1){
        $(this).css({background:'#c22423'})
        $('.box6').css({background:'radial-gradient(circle at 50% 198%,#c22423 36%,#000 60%)'})
    }else if(index==2){
        $(this).css({background:'#d1810e'})
        $('.box6').css({background:'radial-gradient(circle at 50% 198%,#d1810e 36%,#000 60%)'})
    }else if(index==3){
        $(this).css({background:'#4c8730'})
        $('.box6').css({background:'radial-gradient(circle at 50% 198%,#4c8730 36%,#000 60%)'})
    }
    $('.box6_img img').hide()
    $(`.box6_img img:nth-child(${index})`).show()
    $('.box6_text div').hide()
    $(`.box6_text div:nth-child(${index})`).show()
})
 
new Swiper('.box7Swiper', {
	slidesPerView: box7V,
    centeredSlides: true,
    autoplay:true,
    pagination: {
        el: '.box7Swiper-pagination',
    },
    loop:true
})

ScrollTrigger.create({
    trigger:'.box7_title',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box7_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box7_title').removeClass('showup');
    }
})

gsap.to('.box8',{
    scrollTrigger:{
        trigger:'.box8',
        start:'top top+=6%',
        end:'+=250%',
        pin:true,
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 98);
            if(index==0){
                index=1
            }
            $('.box8_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/nx_box6_new_${index}.avif`)
        }
    }
})

ScrollTrigger.create({
    trigger:'.box8_title',
    start:'top bottom-=20%',
    end:'+=0',
    // markers:true,
    onEnter: () => {
        $('.box8_title').addClass('showup');
    },
    onLeaveBack: () => {
        $('.box8_title').removeClass('showup');
    }
})

gsap.from('.box9_text1',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box9_text1',
        start:'top bottom-=20%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})

if(Wflag){
    var box9 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box9',
            start:'top+=23% top',
            end:'+=200%',
            scrub:1,
            // markers:true,
        }
    })
    box9.to('.box9_text1',{opacity:0,y:'-2rem'})
    .to('.box9_img',{scale:0.8,borderRadius:'3rem'})
    .from('.box9_text2',{opacity:0,y:'2rem'},'<')
    .to('.box9_text2',{opacity:0,y:'-2rem'},'+=60%')
    .to('.box9_img img:nth-child(3)',{opacity:1},'<')
    .from('.box9_text3',{opacity:0,y:'2rem'},'-=40%')
    
    gsap.to('.box9',{
        scrollTrigger:{
            trigger:'.box9',
            start:'top+=3% top',
            end:'+=250%',
            pin:true,
            // markers:true,
        }
    })
}else{
    gsap.from('.box9_text2',{
        y:'2rem',opacity:0,duration:0.5,
        scrollTrigger:{
            trigger:'.box9_text1',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
    gsap.from('.box9_text3',{
        y:'2rem',opacity:0,duration:0.5,
        scrollTrigger:{
            trigger:'.box9_text1',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true
        }
    })
}

gsap.from('.box10_title',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box10_title',
        start:'top bottom-=20%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})

gsap.from('.box10_icon',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box10_icon',
        start:'top bottom-=20%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})

gsap.from('.box10_items',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box10_items',
        start:'top bottom-=20%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})

if(Wflag){

    $('.box3_mask img').hover(function(){
        $('.box3_mask img').hide()
        $('.box3_mask img:nth-child(2)').show()
    },function(){
        $('.box3_mask img').hide()
        $('.box3_mask img:nth-child(1)').show()
    })

    var box10 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box10',
            start:'top+=20% top+=6%',
            end:'+=100%',
            scrub:true,
            // markers:true,
        }
    })
    box10.from('.box10_video',{background:'rgba(0,0,0,0)'})
    .from('.box10_video div',{opacity:0})

    gsap.to('.box10',{
        scrollTrigger:{
            trigger:'.box10',
            start:'top top+=6%',
            end:'+=150%',
            pin:true,
            // markers:true,
        }
    })
}


gsap.from('.box11_title',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box11_title',
        start:'top bottom-=20%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})



if(Wflag){
    var box11 = gsap.timeline({
        scrollTrigger:{
            trigger:'.box11',
            start:'top+=20% top+=6%',
            end:'+=200%',
            scrub:1,
            // markers:true,
        }
    })
    box11.to('.box11_items',{x:'-62%'})

    gsap.to('.box11',{
        scrollTrigger:{
            trigger:'.box11',
            start:'top top+=6%',
            end:'+=250%',
            pin:true,
            // markers:true,
        }
    })
}

gsap.from('.box13_title',{
    y:'2rem',opacity:0,duration:0.5,
    scrollTrigger:{
        trigger:'.box13_title',
        start:'top bottom-=30%',
        end:'+=0',
        toggleActions:'play none none reverse',
        // markers:true
    }
})
if(Wflag){
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box13',
            start:'top+=10% top+=2%',
            end:'+=200%',
            scrub:true
        }
    }).to('.box13_cart div:nth-child(1) img:nth-child(2)',{y:'-8.8rem'})
    .to('.box13_items .box13_item:nth-child(1)',{background:'white',color:'black'},'+=100%')
    .to('.box13_items .box13_item:nth-child(2)',{background:'#fc620c',color:'white'},'<')
    .to('.box13_cart div:nth-child(2)',{opacity:'1'},'<')
    .to('.box13_cart div:nth-child(1)',{opacity:'0'},'<')
    .to('.box13_cart div:nth-child(2) img:nth-child(2)',{y:'-8rem'},'+=50%')
    .to('.box13_cart div:nth-child(2) img:nth-child(3)',{y:'-16.6rem'})
    
    gsap.to('.box13',{
        scrollTrigger:{
            trigger:'.box13',
            start:'top top+=2%',
            end:'+=250%',
            pin:true,
            // markers:true,
        }
    })
    gsap.to('.box12',{
        scrollTrigger:{
            trigger:'.box12',
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
            // markers:true,
        }
    })
}else{
    gsap.timeline({
        scrollTrigger:{
            trigger:'.box13',
            start:'top+=10% top+=2%',
            end:'+=150%',
            scrub:true
        }
    }).to('.box13_cart div:nth-child(1) img:nth-child(2)',{y:'-3.2rem'})
    .to('.box13_items',{x:'-50%'},'+=100%')
    .to('.box13_cart div:nth-child(2)',{opacity:'1'},'<')
    .to('.box13_cart div:nth-child(1)',{opacity:'0'},'<')
    .to('.box13_cart div:nth-child(2) img:nth-child(2)',{y:'-2.8rem'},'+=50%')
    .to('.box13_cart div:nth-child(2) img:nth-child(3)',{y:'-5.9rem'})
    
    gsap.to('.box13',{
        scrollTrigger:{
            trigger:'.box13',
            start:'top top+=6%',
            end:'+=200%',
            pin:true,
            // markers:true,
        }
    })
}





new Swiper('.box12Swiper', {
    autoplay:true,
    pagination: {
        el: '.box12Swiper-pagination',
    },
})

$('.box2_items div').click(function(){
    var index = $(this).index()+1
    if(index == 1){
        var element = document.querySelector(".box5");
        element.scrollIntoView({block: "start"});
    }else if(index == 2){
        var element = document.querySelector(".box6");
        element.scrollIntoView({block: "start"});
    }else if(index == 3){
        var element = document.querySelector(".box10");
        element.scrollIntoView({block: "start"});
    }else if(index == 4){
        var element = document.querySelector(".box8");
        element.scrollIntoView({block: "start"});
    }
})

$('.box3_mask img').click(function(){
    var video = $('.box3_1 video')[0]
    if (video.requestFullscreen) {
        video.requestFullscreen();
    }
    // if(window.innerWidth<750){
    //     $('.box3_mask').hide()
    // }
})

//boxSpecs_btn
$('.bs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/collections/all/products/oxva-nexlim-kit'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})
